import { render, staticRenderFns } from "./DealerService.vue?vue&type=template&id=0a5fd329&scoped=true"
import script from "./DealerService.vue?vue&type=script&lang=js"
export * from "./DealerService.vue?vue&type=script&lang=js"
import style0 from "./DealerService.vue?vue&type=style&index=0&id=0a5fd329&prod&lang=css"
import style1 from "./DealerService.vue?vue&type=style&index=1&id=0a5fd329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5fd329",
  null
  
)

export default component.exports